import React from "react";
import { Outlet } from "react-router-dom";
import SidebarLinks from "../../components/ui/SidebarLinks";
import { ContentWrapperWithHeader } from "../../components/ui/Content";
import Breadcrumbs from "../../components/ui/Content/Breadcrumbs";
import useRestrictedSettings from "../../restrictions/useRestrictedSettings";
function Settings() {
  const links = useRestrictedSettings();
  return (
    <div className="pt-36 pb-16 flex h-screen gap-2 lg:gap-4">
      <div className="w-[clamp(220px,22vw,360px)] shrink-0">
        <SidebarLinks title="Settings" navLinks={links} />
      </div>
      <main className="w-full h-full pr-3 sm:pr-5 lg:pr-8 min-w-0">
        <ContentWrapperWithHeader
          title={<Breadcrumbs />}
          content={<Outlet />}
        />
      </main>
    </div>
  );
}

export default Settings;
